const DATE_LABELS = {
    Expired: "Table##user date statuses##expired",
    Expires: "Table##user date statuses##expires",
    NeverExpires: "Table##user date statuses##never expires",
    Sent: "Table##user date statuses##sent"
} as const;

export { DATE_LABELS };
